import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  margin: 8px 0 15px;
  width: 100%;
  color: #9598ab;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;

  span {
    flex: none;
  }
`
